import React, { useEffect, useState } from "react";
import TabsComponent from "../../../components/shared/tabs/TabsComponent";
import { useNavigate, useLocation } from "react-router-dom";
import EmployeeDetailTab from "./EmployeeDetailTab";
import { useGetWorkingAreasQuery } from "../../../app/globalApi";
import {
  getAllowedTabsByRole,
  jwtDecode,
} from "../../../helpers/AccessControlUtils";

let allowedTabs = [];

const EmployeeDetail = () => {
  const decodedToken = jwtDecode();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const [tabsData, setTabsData] = useState([]);
  const { data: workingAreas, isLoading } = useGetWorkingAreasQuery();

  useEffect(() => {
    if (workingAreas && workingAreas.data) {
      allowedTabs = getAllowedTabsByRole(decodedToken.role);
      const tabs = [];
      workingAreas.data.forEach((workingArea) => {
        if (allowedTabs.includes(workingArea.name)) {
          tabs.push({
            label: workingArea.name,
            eventKey: workingArea.id,
            content: <></>,
          });
        }
      });
      setTabsData(tabs);
    }
  }, [workingAreas]);

  useEffect(() => {
    if (tabsData.length > 0) {
      setActiveKey(tabsData[0].eventKey);
    }
  }, [tabsData]);

  useEffect(() => {
    if (activeKey) {
      addQueryParam("activeTab", activeKey);
    }
  }, [activeKey]);

  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {!isLoading && activeKey && (
        <>
          <div className="tabs_outer">
            <TabsComponent
              tabs={tabsData}
              defaultKey={activeKey}
              layout="horizontal"
              setActiveKey={setActiveKey}
            />
            <div className="tabs_content">
              <EmployeeDetailTab tab={activeKey} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EmployeeDetail;
